import { createReducer } from '@reduxjs/toolkit'
import { types } from '../../actions/projects/form_actions'

const makeItemSelected = (state, listKey, itemId) => {
  state[listKey] = state[listKey].map(item => ({
    ...item,
    selected: item.value == itemId
  }))
}

export default createReducer({}, (builder) => {
  builder
    .addCase(types.INIT_COMPANY_LIST, (state, action) => {
      state.companies = action.companies || []
    })
    .addCase(types.INIT_GROUP_SELECTOR_DATA, (state, action) => {
      const { type, ...data } = action
      Object.assign(state, data)
    })
    .addCase(types.LOAD_PROJECT_GROUPS + '_REQUEST', (state, action) => {
      state.groups = []
      state.fieldsHtml = ''
      makeItemSelected(state, 'companies', action.companyId)
    })
    .addCase(types.LOAD_PROJECT_GROUPS, (state, action) => {
      const groups = action.data.groups
      state.groups = groups || []
      makeItemSelected(state, 'companies', action.data.company_id)
    })
    .addCase(types.LOAD_ADDITIONAL_FORM_FIELDS + '_REQUEST', (state, action) => {
      makeItemSelected(state, 'groups', action.groupId)
    })
    .addCase(types.LOAD_ADDITIONAL_FORM_FIELDS, (state, action) => {
      state.fieldsHtml = action.data.form_fields
    })
    // ServiceCompany input
    .addCase(`${types.CREATE_NEW_SERVICE_COMPANY}_FAILURE`, (state, action) => {
      if (!state.createServiceCompany) state.createServiceCompany = {}
      state.createServiceCompany.error = action.error.message
    })
    .addCase(types.CREATE_NEW_SERVICE_COMPANY, (state, action) => {
      const newCompany = action.data.data
      if (!state.createServiceCompany) state.createServiceCompany = {}
      state.createServiceCompany.success = action.data.message
      
      if (!state.availableVendors) state.availableVendors = []
      if (!state.vendors) state.vendors = []
      
      const newVendor = {
        value: newCompany.id,
        label: newCompany.name,
      }
      state.availableVendors.push(newVendor)
      state.vendors.push(newVendor)
    })
    .addCase(types.RESET_CREATE_SERVICE_COMPANY_STATUS_MESSAGES, (state) => {
      if (!state.createServiceCompany) state.createServiceCompany = {}
      state.createServiceCompany.error = null
      state.createServiceCompany.success = null
    })
    .addCase(types.SET_AVAILABLE_VENDORS, (state, action) => {
      state.availableVendors = action.vendors || []
    })
    .addCase(types.SET_VENDORS, (state, action) => {
      state.vendors = action.vendors || []
    })
    // Installers input
    .addCase(types.CREATE_NEW_INSTALLER + '_FAILURE', (state, action) => {
      if (!state.createInstaller) state.createInstaller = {}
      state.createInstaller.error = action.error.message
    })
    .addCase(types.CREATE_NEW_INSTALLER, (state, action) => {
      const newInstaller = action.data.user
      if (!state.createInstaller) state.createInstaller = {}
      state.createInstaller.success = action.data.message
      
      if (!state.availableInstallers) state.availableInstallers = []
      if (!state.installers) state.installers = []
      
      const newInstallerOption = {
        value: newInstaller.id,
        label: newInstaller.name,
      }
      state.availableInstallers.push(newInstallerOption)
      state.installers.push(newInstallerOption)
    })
    .addCase(types.RESET_CREATE_INSTALLER_STATUS_MESSAGES, (state) => {
      if (!state.createInstaller) state.createInstaller = {}
      state.createInstaller.error = null
      state.createInstaller.success = null
    })
    .addCase(types.SET_AVAILABLE_INSTALLERS, (state, action) => {
      state.availableInstallers = action.installers || []
    })
    .addCase(types.SET_INSTALLERS, (state, action) => {
      state.installers = action.installers || []
    })
    // ProjectTags input
    .addCase(`${types.CREATE_NEW_PROJECT_TAG}_FAILURE`, (state, action) => {
      if (!state.createProjectTag) state.createProjectTag = {}
      state.createProjectTag.error = action.error.message
    })
    .addCase(types.CREATE_NEW_PROJECT_TAG, (state, action) => {
      const newTag = action.data.tag
      if (!state.createProjectTag) state.createProjectTag = {}
      state.createProjectTag.success = action.data.message
      
      if (!state.availableProjectTags) state.availableProjectTags = []
      if (!state.projectTags) state.projectTags = []
      
      const newTagOption = {
        value: newTag.id,
        label: newTag.name,
      }
      state.availableProjectTags.push(newTagOption)
      state.projectTags.push(newTagOption)
    })
    .addCase(types.RESET_CREATE_PROJECT_TAG_STATUS_MESSAGES, (state) => {
      if (!state.createProjectTag) state.createProjectTag = {}
      state.createProjectTag.error = null
      state.createProjectTag.success = null
    })
    .addCase(types.SET_AVAILABLE_PROJECT_TAGS, (state, action) => {
      state.availableProjectTags = action.projectTags || []
    })
    .addCase(types.SET_PROJECT_TAGS, (state, action) => {
      state.projectTags = action.projectTags || []
    })
    // FinanceTags input
    .addCase(`${types.CREATE_NEW_FINANCE_TAG}_FAILURE`, (state, action) => {
      if (!state.createFinanceTag) state.createFinanceTag = {}
      state.createFinanceTag.error = action.error.message
    })
    .addCase(types.CREATE_NEW_FINANCE_TAG, (state, action) => {
      const newFinanceTag = action.data.tag
      if (!state.createFinanceTag) state.createFinanceTag = {}
      state.createFinanceTag.success = action.data.message
      
      if (!state.availableFinanceTags) state.availableFinanceTags = []
      if (!state.financeTags) state.financeTags = []
      
      const newFinanceTagOption = {
        value: newFinanceTag.id,
        label: newFinanceTag.name,
      }
      state.availableFinanceTags.push(newFinanceTagOption)
      state.financeTags.push(newFinanceTagOption)
    })
    .addCase(types.RESET_CREATE_FINANCE_TAG_STATUS_MESSAGES, (state) => {
      if (!state.createFinanceTag) state.createFinanceTag = {}
      state.createFinanceTag.error = null
      state.createFinanceTag.success = null
    })
    .addCase(types.SET_AVAILABLE_FINANCE_TAGS, (state, action) => {
      state.availableFinanceTags = action.financeTags || []
    })
    .addCase(types.SET_FINANCE_TAGS, (state, action) => {
      state.financeTags = action.financeTags || []
    })
    // Locations input
    .addCase(types.SET_LOCATION, (state, action) => {
      state.location = action.location
    })
    .addCase(types.SET_AVAILABLE_LOCATIONS, (state, action) => {
      state.availableLocations = action.locations || []
    })
    .addCase(types.CREATE_NEW_LOCATION + '_FAILURE', (state, action) => {
      if (!state.createLocation) state.createLocation = {}
      state.createLocation.error = action.error.message
    })
    .addCase(types.CREATE_NEW_LOCATION_ELEMENT + '_FAILURE', (state, action) => {
      state.createLocationElementMessage = action.data.message
      state.createLocationElementSuccess = action.data.success
    })
    .addCase(types.CREATE_NEW_LOCATION, (state, action) => {
      const newLocation = action.data.location
      if (!state.createLocation) state.createLocation = {}
      state.createLocation.success = action.data.message
      
      if (!state.availableLocations) state.availableLocations = []
      
      const locationNumber = newLocation.number || ''
      const newLocationOption = {
        value: newLocation.id,
        label: `${locationNumber} - ${newLocation.name}`,
        url: `/locations/${newLocation.id}/items`,
      }
      // insert new one in front of the list
      state.availableLocations.unshift(newLocationOption)
      state.location = newLocationOption
    })
    .addCase(types.UPDATE_LOCATION_ELEMENT, (state, action) => {
      if (action.data.success) {
        if (!state.elements) state.elements = []
        if (!state.selected_elements) state.selected_elements = []
        state.elements.push(action.data.element)
        state.selected_elements.push(action.data.element)
      }
      state.createLocationElementMessage = action.data.message
      state.createLocationElementSuccess = action.data.success
    })
    .addCase(types.RESET_CREATE_LOCATION_STATUS_MESSAGES, (state) => {
      if (!state.createLocation) state.createLocation = {}
      state.createLocation.error = null
      state.createLocation.success = null
    })
    .addCase(types.RESET_CREATE_LOCATION_ELEMENT_STATUS_MESSAGES, (state) => {
      state.createLocationElementMessage = null
      state.createLocationElementSuccess = null
    })
    .addCase(types.SET_ELEMENT_GROUPS, (state, action) => {
      state.element_groups = action.element_groups || []
    })
    .addCase(types.LOAD_INSTALLERS_SUCCESS, (state, action) => {
      state.availableInstallers = action.data.installers || []
    })
    .addCase(types.LOAD_ELEMENTS_SUCCESS, (state, action) => {
      state.elements = action.data.element_ids_options || []
    })
    .addCase(types.SET_SELECTED_ELEMENTS, (state, action) => {
      state.selected_elements = action.elements || []
    })
})
